import { Component, computed, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowSelectEvent,
} from 'primeng/table';
import { RisikoOpkraevningerService } from '../risiko-opkraevninger.service';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { DatePipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-opkraevning-result',
  imports: [
    CprNummerPipe,
    DatePipe,
    DecimalPipe,
    TableModule,
    TableRowDirective,
    KeepScrollPositionDirective,
  ],
  templateUrl: './opkraevning-result.component.html',
  styleUrl: './opkraevning-result.component.css',
})
export class OpkraevningResultComponent {
  opkraevningService = inject(RisikoOpkraevningerService);
  data = this.opkraevningService.datasource.data;
  tableData = computed(() => this.data()?.data || []);

  onRowSelect(e: TableRowSelectEvent) {
    this.opkraevningService.selectOpkraevningResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.opkraevningService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
